import { useNavigate } from "react-router-dom";

import { CRE_FINAL_ASSESSMENT_RESULT } from "../../../../utils/cookiesmanager";

import AssessmentFailIcon from '../../../../assets/images/assessment-fail-icon.svg';
import AssessmentSuccessIcon from '../../../../assets/images/assessment-success-icon.svg';

import Button from "../../lms/ButtonComponent";
import { BUTTON_VARIANTS } from "../../lms/constant";

import styles from "./styles.module.scss";
import { useGetTranslatedText } from "../../lms/queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

const AssessmentResultModal = ({handleTryAgain}) => {
  const navigate = useNavigate();

  const creAssessmentFinalResult = localStorage.getItem(CRE_FINAL_ASSESSMENT_RESULT);

  const result = creAssessmentFinalResult ? JSON.parse(creAssessmentFinalResult) :{};

  const {resultPercentage , assessmentResult , correctQuestion , totalQuestion , wrongQuestion } = result || {};

  const handleClick = () => {
    navigate('/user/dashboard')
  }

  const languageId = localStorage.getItem("l_id") || 1;
      
  const { data: translatedTextResponse } = useGetTranslatedText(languageId);
      
  const { data: translatedText = [] } = translatedTextResponse || {};

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        
        {/* Top Icon */}
        <div className={styles.iconWrapper}>
          <div className={assessmentResult === 'Fail' ? styles['red-badge'] :styles.badge}>
            {
              assessmentResult === 'Fail'
              ?
              <img src={AssessmentFailIcon} alt="" />
              :
              <img src={AssessmentSuccessIcon} alt="" />
            }
            </div>
        </div>

        {/* Title */}
        <h2 className={styles.title}>{
        assessmentResult === 'Fail'  ? 
        getTranslatedText(
        translatedText,
        "not_this_time",
        "Not this time!",
        ) 
        : 
        getTranslatedText(
        translatedText,
        "congratulations",
        'Congratulations!',
        )}
        </h2>
        <p className={styles.subtitle}>
        { assessmentResult === 'Fail' 
         ? 
        getTranslatedText(
        translatedText,
        "try_again_desc",
        'You need to score at least 60% to pass. Please reattempt the assessment!',
        )
         :
        getTranslatedText(
        translatedText,
        "you_have_successfully_passed_the_assessment",
        'You have successfully passed the assessment.',
        )
        }
        </p>
        {/* Score Card */}
        <div className={styles.card}>
          <div className={styles.percentage}>
            {resultPercentage}
          </div>
          <p className={styles.label}>
          {
          getTranslatedText(
          translatedText,
          "your_score",
          'Your score',
        )
        }
        </p>

          {/* Progress Bar */}
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `${resultPercentage}` }}
            />
          </div>

          {/* Stats */}
          <div className={styles.stats}>
            <div className={`${styles.statBox} ${styles['statBox__total']}`}>
              <p className={styles['statBox__label']}>
                {
                  getTranslatedText(
                  translatedText,
                  "total",
                  'Total',
                  )
                }
                </p>
              <h4 className={styles['statBox__value']}>{totalQuestion}</h4>
            </div>

            <div className={`${styles.statBox} ${styles['statBox__correct']}`}>
              <p className={styles['statBox__label']}>
                {
                  getTranslatedText(
                  translatedText,
                  "correct",
                  'Correct',
                  )
                }
                </p>
              <h4 className={styles['statBox__value']} >{correctQuestion}</h4>
            </div>

            <div className={`${styles.statBox} ${styles['statBox__wrong']}`}>
              <p  className={styles['statBox__label']}>
                {
                  getTranslatedText(
                  translatedText,
                  "wrong",
                  'Wrong',
                  )
                }
                </p>
              <h4 className={styles['statBox__value']}>{wrongQuestion}</h4>
            </div>
          </div>
        </div>

       {
        assessmentResult === 'Fail'
        ?
        <div className={styles['button-container']}>
          <Button  
          label={
            getTranslatedText(
                  translatedText,
                  "back_to_home",
                  'Back to Home',
                  )
                }
          className={styles['cancel-button']} 
          buttonVariant={BUTTON_VARIANTS.TERNARY} 
          onClick={handleClick} />
          <Button label={
            getTranslatedText(
                  translatedText,
                  "key_try_again",
                  'Try again',
                  )
            } className={styles['try-again']} buttonVariant={BUTTON_VARIANTS.PRIMARY} onClick={handleTryAgain} />
        </div>
        :
        <Button className={styles.button} label='Back to Home' buttonVariant={BUTTON_VARIANTS.PRIMARY} onClick={handleClick}  />
       }
        
      </div>
    </div>
  );
};

export default AssessmentResultModal;